import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as dashboardActions from '../actions/dashboard';
import { fetchingState } from '@constants';

const initialState = {
  totalCases: { data: [], state: null },
  propTypes: { data: [], state: null },
  appealTypes: { data: [], state: null },
  statistics: { data: [], state: null },
  detail: { data: [], state: null },
  informalDetail: { data: [], state: null },
  formalDates: { data: [], state: null },
  informalDates: { data: [], state: null },
  fourteenDay: { data: [], state: null },
  notScheduled: { data: [], state: null },
  date: null,
  view: 'main',
  teamFormal: { data: [], state: null },
  teamInformal: { data: [], state: null },
  teamProductivity: { data: [], state: null },
  viewProductivity: false,
  appraiser: 'All',
  productivityRowData: [],
  productivityColumnDefs: [],
  productivityFilter: 'thisMonth',
  productivityDateFrom: null,
  productivityDateTo: null,
  taxingUnit: null,
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case dashboardActions.SET_DASHBOARD_PRODUCTIVITY_ROWDATA:
      return state.setIn(['productivityRowData'], action.data);
    case dashboardActions.SET_DASHBOARD_PRODUCTIVITY_COLUMNDEFS:
      return state.setIn(['productivityColumnDefs'], action.data);
    case dashboardActions.SET_DASHBOARD_PRODUCTIVITY_FILTER:
      return state.setIn(['productivityFilter'], action.data);
    case dashboardActions.SET_DASHBOARD_PRODUCTIVITY_DATEFROM:
      return state.setIn(['productivityDateFrom'], action.data);
    case dashboardActions.SET_DASHBOARD_PRODUCTIVITY_DATETO:
      return state.setIn(['productivityDateTo'], action.data);

    case dashboardActions.SET_DASHBOARD_APPRAISER:
      return state.setIn(['appraiser'], action.data);
    case dashboardActions.SET_DASHBOARD_VIEW_PRODUCTIVITY:
      return state
        .setIn(['viewProductivity'], action.data)
        .setIn(['productivityRowData'], [])
        .setIn(['productivityColumnDefs'], [])
        .setIn(['productivityFilter'], 'thisMonth')
        .setIn(['productivityDateFrom'], null)
        .setIn(['productivityDateTo'], null);
    case dashboardActions.SET_DASHBOARD_VIEW:
      return state.setIn(['view'], action.data);
    // .setIn(['totalCases'], fromJS({ data: [], state: null }))
    // .setIn(['propTypes'], fromJS({ data: [], state: null }))
    // .setIn(['appealTypes'], fromJS({ data: [], state: null }))
    // .setIn(['statistics'], fromJS({ data: [], state: null }))
    // .setIn(['detail'], fromJS({ data: [], state: null }))
    // .setIn(['formalDates'], fromJS({ data: [], state: null }))
    // .setIn(['informalDates'], fromJS({ data: [], state: null }))
    // .setIn(['fourteenDay'], fromJS({ data: [], state: null }))
    // .setIn(['notScheduled'], fromJS({ data: [], state: null }));
    case dashboardActions.SET_DASHBOARD_DATE:
      return state.setIn(['date'], action.data);
    case dashboardActions.SET_DASHBOARD_TAXING_UNIT:
      return state.setIn(['taxingUnit'], action.data);

    case dashboardActions.DASHBOARD_TEAM_GET_FORMAL[START]: {
      return state.setIn(['teamFormal', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_TEAM_GET_FORMAL[SUCCESS]: {
      return state
        .setIn(['teamFormal', 'state'], fetchingState.LOADED)
        .setIn(['date'], new Date())
        .setIn(
          ['teamFormal', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_TEAM_GET_FORMAL[ERROR]: {
      return state.setIn(['teamFormal', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_TEAM_GET_INFORMAL[START]: {
      return state.setIn(['teamInformal', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_TEAM_GET_INFORMAL[SUCCESS]: {
      return state
        .setIn(['teamInformal', 'state'], fetchingState.LOADED)
        .setIn(
          ['teamInformal', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_TEAM_GET_INFORMAL[ERROR]: {
      return state.setIn(['teamInformal', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_TEAM_GET_PRODUCTIVITY[START]: {
      return state.setIn(['teamProductivity', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_TEAM_GET_PRODUCTIVITY[SUCCESS]: {
      return state
        .setIn(['teamProductivity', 'state'], fetchingState.LOADED)
        .setIn(
          ['teamProductivity', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_TEAM_GET_PRODUCTIVITY[ERROR]: {
      return state.setIn(['teamProductivity', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_TOTAL_CASES[START]: {
      return state.setIn(['totalCases', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_TOTAL_CASES[SUCCESS]: {
      if(action.taxingUnitID === state.get('taxingUnit')) {
        return state
        .setIn(['totalCases', 'state'], fetchingState.LOADED)
        .setIn(['date'], new Date())
        .setIn(
          ['totalCases', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
      }
      return state;
    }
    case dashboardActions.DASHBOARD_GET_TOTAL_CASES[ERROR]: {
      return state.setIn(['totalCases', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_APPEAL_TYPES[START]: {
      return state.setIn(['appealTypes', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_APPEAL_TYPES[SUCCESS]: {
      return state
        .setIn(['appealTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['appealTypes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_APPEAL_TYPES[ERROR]: {
      return state.setIn(['appealTypes', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_PROPTYPES[START]: {
      return state.setIn(['propTypes', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_PROPTYPES[SUCCESS]: {
      return state
        .setIn(['propTypes', 'state'], fetchingState.LOADED)
        .setIn(
          ['propTypes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_PROPTYPES[ERROR]: {
      return state.setIn(['propTypes', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.FETCH_STATISTICS[START]: {
      return state.setIn(['statistics', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.FETCH_STATISTICS[SUCCESS]: {
      return state
        .setIn(['statistics', 'state'], fetchingState.LOADED)
        .setIn(
          ['statistics', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.FETCH_STATISTICS[ERROR]: {
      return state.setIn(['statistics', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_DETAIL[START]: {
      return state.setIn(['detail', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_DETAIL[SUCCESS]: {
      return state
        .setIn(['detail', 'state'], fetchingState.LOADED)
        .setIn(['detail', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case dashboardActions.DASHBOARD_GET_DETAIL[ERROR]: {
      return state.setIn(['detail', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_INFORMAL_DETAIL[START]: {
      return state.setIn(['informalDetail', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_INFORMAL_DETAIL[SUCCESS]: {
      return state
        .setIn(['informalDetail', 'state'], fetchingState.LOADED)
        .setIn(['informalDetail', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case dashboardActions.DASHBOARD_GET_INFORMAL_DETAIL[ERROR]: {
      return state.setIn(['informalDetail', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_FORMAL_DATES[START]: {
      return state.setIn(['formalDates', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_FORMAL_DATES[SUCCESS]: {
      return state
        .setIn(['formalDates', 'state'], fetchingState.LOADED)
        .setIn(
          ['formalDates', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_FORMAL_DATES[ERROR]: {
      return state.setIn(['formalDates', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_INFORMAL_DATES[START]: {
      return state.setIn(['informalDates', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_INFORMAL_DATES[SUCCESS]: {
      return state
        .setIn(['informalDates', 'state'], fetchingState.LOADED)
        .setIn(
          ['informalDates', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_INFORMAL_DATES[ERROR]: {
      return state.setIn(['formalDates', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_14_DAY_DATA[START]: {
      return state.setIn(['fourteenDay', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_14_DAY_DATA[SUCCESS]: {
      return state
        .setIn(['fourteenDay', 'state'], fetchingState.LOADED)
        .setIn(
          ['fourteenDay', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_14_DAY_DATA[ERROR]: {
      return state.setIn(['fourteenDay', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_NOT_SCHEDULED[START]: {
      return state.setIn(['notScheduled', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_NOT_SCHEDULED[SUCCESS]: {
      return state
        .setIn(['notScheduled', 'state'], fetchingState.LOADED)
        .setIn(
          ['notScheduled', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_NOT_SCHEDULED[ERROR]: {
      return state.setIn(['notScheduled', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
